<template>
  <div class="text-row-balance" @click="goDetails(balanceData)">
    <div class="tips">
      <p class="l-text">{{balanceData.type_name}}</p>
      <p class="r-text">{{balanceData.changeTime || "-- --"}}</p>
    </div>

    <div class="price out-text" v-if="balanceData.dcFlag == 0">
      +{{balanceData.changeBal || 0}}
    </div>
    <div class="price in-text" v-if="balanceData.dcFlag == 1"> 
      -{{balanceData.changeBal || 0}}
    </div>
  </div>
</template>
 
<script>
export default {
  name: "TextRowBalance",
  props: {
    balanceData: {
      type: Object,
      default: {},
    },
  },
  components: {},
  data() {
    return {
      // balanceData: {   
      // id: "",
      // dcFlag: "变更类型：0增加余额 1减少余额",
      // type: "类型 0=充值 1=充值赠送 2=洗车订单",
      // changeBal: "金额",
      // changeTime: "时间",
      // type_name: "类型名称",
      // }
    };
  },
  created() {},
  mounted() {},
  methods: {
       goDetails(Data) {  
        this.$router.push({
          name: "balance-log-details",
          query: {
            id: Data.id,
          },
        }); 
    },
  },
};
</script>

<style lang="scss" scoped>
.text-row-balance {
  width: 100%;
  background-color: #fff;
  padding: 15px 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #eeeeee;

  .tips {
    padding: 0 10px;
    text-align: left;

    .l-text {
      font-size: 13px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 21px;
    }
    .r-text {
      font-size: 13px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #999999;
      line-height: 21px;
    }
  }
  .price {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold; 
    line-height: 21px;
  }

  .in-text {
    color: #333333;
  }
  .out-text {
    color: #f03535;
  }
}
</style>
